import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import {
  PreloadAllModules,
  provideRouter,
  withComponentInputBinding,
  withPreloading,
} from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import { httpErrorInterceptor } from './packages-angular/core/interceptors/error-handler.interceptor';
import { httpLoadingInterceptor } from './packages-angular/core/interceptors/http.loading.interceptor';
import { httpTokenInterceptor } from './packages-angular/core/interceptors/http.token.interceptor';
registerLocaleData(es);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withComponentInputBinding()
    ),
    provideHttpClient(
      withInterceptors([
        httpErrorInterceptor,
        httpLoadingInterceptor,
        httpTokenInterceptor,
      ])
    ),
    { provide: LOCALE_ID, useValue: 'en-ES' },
  ],
};
